import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import "core-js";
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { icons } from "./assets/icons";
import { Provider } from "react-redux";
import store from "./store";
import PivotGrid from "devextreme/ui/pivot_grid";
import PivotGridFieldChooser from "devextreme/ui/pivot_grid_field_chooser";

React.icons = icons;

// Set global default options to keep "Select All" visible in header filter search results
PivotGrid.defaultOptions({
  options: {
    headerFilter: {
      hideSelectAllOnSearch: false,
    },
  },
});
PivotGridFieldChooser.defaultOptions({
  options: {
    headerFilter: {
      hideSelectAllOnSearch: false,
    },
  },
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
